module.exports = __webpack_public_path__ + "img/AzadBarzinji-Chawakani.8e5d1fb0.jpg";